/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv } from '../../styles/styles';
import EditVoucher from './EditVoucher';
import VoucherInfoComponent from './VoucherInfoComponent';
import ApplyPayment from './ApplyPayment';

const VoucherInfo = () => {
  const { voucherID } = useParams();
  const { authStore, dataStore, orgStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [voucher, setVoucher] = useState(null);
  const [voucherTrans, setVoucherTrans] = useState([]);
  const [paymentVouchers, setPaymentVouchers] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [dLink, setDLink] = useState('#');
  const payments = dataStore.paymentArray;
  const { settings } = orgStore;
  const { ExtSysId } = settings;

  const fetchVoucher = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/voucher/${voucherID}`,
      );
      setVoucher(data);
    } catch (e) {
      console.error(e);
    }
  };
  const fetchVoucherTransactions = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/voucher-transactions/${voucherID}`,
      );
      setVoucherTrans(data);
    } catch (e) {
      console.error(e);
    }
  };
  const fetchPaymentVouchers = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/mapped-payment-and-voucher-voucher/${voucherID}`,
      );
      setPaymentVouchers(data);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchVoucherURL = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/voucher-xero-deeplink/${voucherID}`,
      );
      return data;
    } catch (e) {
      console.error(e);
    }
  };

  const configureDeepLink = async () => {
    const result = await fetchVoucherURL();
    if (result) {
      const {
        ObjectId,
        VoucherTypeCode,
        AccountId,
        OrganisationShortCode: shortCode,
      } = result;
      let route = '';

      switch (VoucherTypeCode) {
        case 'RCR':
          route = `https://go.xero.com/AccountsReceivable/ViewCreditNote.aspx?shortcode=${shortCode}&creditNoteID=${ObjectId}`;
          break;
        case 'PCR':
          route = `https://go.xero.com/AccountsPayable/ViewCreditNote.aspx?shortcode=${shortCode}&creditNoteID=${ObjectId}`;
          break;

        case 'PAY':
          route = `https://go.xero.com/AccountsPayable/Edit.aspx?shortcode=${shortCode}&InvoiceID=${ObjectId}`;
          break;
        case 'REC':
          route = `https://go.xero.com/AccountsReceivable/Edit.aspx?shortcode=${shortCode}&InvoiceID=${ObjectId}`;
          break;
        case 'RDP':
          route = `https://go.xero.com/Bank/ViewTransaction.aspx?shortcode=${shortCode}&bankTransactionID=${ObjectId}&accountID=${AccountId}`;
          break;
        case 'PDP':
          route = `https://go.xero.com/Bank/ViewTransaction.aspx?shortcode=${shortCode}&bankTransactionID=${ObjectId}&accountID=${AccountId}`;
          break;
        default:
          route = '#';
      }
      setDLink(route);
    }
  };

  useEffect(() => {
    const initialActions = async () => {
      setLoading(true);
      const promises = [
        fetchVoucher(),
        fetchVoucherTransactions(),
        fetchPaymentVouchers(),
        authStore.retrieveUser(),
      ];

      if (ExtSysId > 0) {
        promises.push(configureDeepLink());
      }
      await Promise.all(promises);
      if (payments.length === 0) {
        // Currently we can't map invoices to payments. So why bother waiting on the payments?
        // promises.push(dataStore.retrieveAllPayments());
        dataStore.retrieveAllPayments();
      }
      setLoading(false);
    };
    initialActions();
  }, [voucherID]);

  if (isLoading || !voucher) return <Spinner />;

  return (
    <Observer
      render={() => {
        if (editMode)
          return (
            <FlexDiv>
              <EditVoucher
                setEditMode={setEditMode}
                voucher={voucher}
                fetchVoucher={fetchVoucher}
              />
            </FlexDiv>
          );
        return (
          <FlexDiv>
            <div
              style={{
                width: '100%',
                maxWidth: '1400px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <VoucherInfoComponent
                voucher={voucher}
                voucherTrans={voucherTrans}
                setEditMode={setEditMode}
                deepLink={dLink}
                setVoucher={setVoucher}
                fetchVoucher={fetchVoucher}
              />
              <ApplyPayment
                voucher={voucher}
                paymentVouchers={paymentVouchers}
                fetchPaymentVouchers={fetchPaymentVouchers}
                fetchVoucher={fetchVoucher}
              />
            </div>
          </FlexDiv>
        );
      }}
    />
  );
};

export default VoucherInfo;
